function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 15.745H5.858l2.497 2.544-1.061 1.061L3 14.995l4.292-4.353 1.061 1.061-2.495 2.542H14v1.5zM10 9.728h8.142l-2.497 2.544 1.061 1.06L21 8.979l-4.292-4.353-1.061 1.06 2.495 2.543H10v1.5z",
  fill: "#111"
});

function SvgSwapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgSwapIcon;